import { render, staticRenderFns } from "./replyList.vue?vue&type=template&id=2a29c65d&scoped=true&"
import script from "./replyList.vue?vue&type=script&lang=js&"
export * from "./replyList.vue?vue&type=script&lang=js&"
import style0 from "./replyList.vue?vue&type=style&index=0&id=2a29c65d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a29c65d",
  null
  
)

export default component.exports